import { createFileRoute, Link } from "@tanstack/react-router";
import { Mail, Shield } from "lucide-react";
import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";

export const Route = createFileRoute("/verify-email")({
  head: () => ({ meta: [{ title: "ClaimGuard | Verify your email" }] }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <SiteHeader />
      <main className="flex-1">
        <div className="container-page grid place-items-center py-14">
          <div className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-sm">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-navy/10 text-navy">
              <Mail className="h-6 w-6" />
            </div>
            <h1 className="text-xl font-semibold tracking-tight">Verify your email</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              We sent a confirmation link to the email on file. Open it to activate your account,
              then return here to sign in.
            </p>
            <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
              <Link
                to="/login"
                className="inline-flex items-center justify-center rounded-md bg-navy px-4 py-2 text-sm font-semibold text-navy-foreground hover:opacity-90"
              >
                <Shield className="mr-2 h-4 w-4" /> Go to sign in
              </Link>
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-md border border-input px-4 py-2 text-sm font-medium hover:bg-accent"
              >
                Back home
              </Link>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
